import { Component } from '@angular/core';

@Component({
  selector: 'app-change',
  standalone: true,
  imports: [],
  templateUrl: './change.component.html',
  styleUrls: ['./change.component.css'],
})
export class ChangeComponent {

}
